import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import type { TriggerProps } from '@atlaskit/tooltip';
import IssueInfo from './issue-info/index.tsx';

const IssueCard = ({
	issueType,
	issueKey,
	issueSummary,
	iconUrl,
	tooltipProps,
}: {
	issueType: string;
	issueKey: string;
	issueSummary: string;
	iconUrl: string;
	tooltipProps?: TriggerProps;
}) => (
	<Box xcss={issueCardStyles}>
		<IssueInfo
			tooltipProps={tooltipProps}
			issueType={issueType}
			issueKey={issueKey}
			issueSummary={issueSummary}
			iconUrl={iconUrl}
		/>
	</Box>
);

const issueCardStyles = xcss({
	backgroundColor: 'elevation.surface.raised',
	padding: 'space.100',
	paddingLeft: 'space.150',
	paddingRight: 'space.150',
	boxShadow: 'elevation.shadow.raised',
	borderRadius: 'border.radius',
});

export default IssueCard;
